export const BDX_CURRENCY_TYPES = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'DKK', 'NOK', 'SEK']

export const BDX_ACCOUNT_TYPES = ['Vitesse', 'Non-Vitesse']

export const JURISDICTION_TYPES = ["US", "UK", "Canada", "South Africa", "EEA", "Australia", "Hong Kong", "Lloyds Brussels"]
